import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { WorksheetModel } from '../../models';
import WorksheetChangesCount from './WorksheetChangesCount';
import './WorksheetRendererHeader.less';

interface Props {
    worksheet: WorksheetModel;
}

const WorksheetRendererHeader: React.FC<Props> = ({ worksheet }) => {
    return (
        <div className="worksheet-renderer-header-container">
            <div className="left-container">
                <span className={`business-id-label ${worksheet.businessId ? 'has-business-id' : ''}`}>
                    {worksheet.businessId ? `${worksheet.businessId}` : 'Business: – EMPTY –'}
                </span>

                <div className={`worksheet-status-container ${worksheet.status.toLowerCase()}`}>
                    <span>{worksheet.status}</span>
                </div>
            </div>

            <div className="right-container">
                <WorksheetChangesCount worksheet={worksheet} />
            </div>
        </div>
    );
};

export default observer(WorksheetRendererHeader);
